module.exports = __webpack_public_path__ + "media/images/hero/hero2-person-corner-left-149153a22297093b066ab5feba5e2723.svg";